<header class="page_header">
  <div class="header_content">
    <div class="text_and_supporting_text">
      <div class="page_title">Job Orders</div>
      <div class="page_desc"></div>
    </div>
    <div class="dropdown" (click)="toggleDropdown($event)">
      <button class="add_new_btn">
        Create Job Order
        <app-svg-icon [path]="'/assets/icons/select_down_arrow.svg'" class="select_down_arrow_icon"></app-svg-icon>
      </button>
      <ul class="dropdown-menu" *ngIf="dropdownVisible">
        <li *ngFor="let jobOrderType of jobOrderTypeList" (click)="selectOption(jobOrderType)">
          {{ jobOrderType.value }}
        </li>
      </ul>
    </div>
  </div>
</header>


<app-tos-table
    [showTableStats]="false"
    [tableMeta]="tableMeta"
    [viewConfig]="jobOrderConfig.viewConfig"
    [filterConfig]="jobOrderConfig.filterConfig"
    [searchBarConfig]="jobOrderConfig.searchBarConfig"
    [tableMenuOptions]="menuOptions"
    [(dataListRequest)]="tableListRequest"
    [dataListResponse]="tableListData"
    [(allTableRecordsSelected)]="allTableRecordsSelected"
    [(selectedItems)]="selectedItems"
    (tosTableAction)="fetchAllRecords()"
    (onViewChange)="handleViewChange($event)"
    (tableMenuOptionSelected)="handleMenuSelection($event)"
  ></app-tos-table>
